import React, { useState,useEffect} from "react"
import { useDispatch, useSelector } from 'react-redux'
import axios from "axios"
import {Card, Row, Col,Container } from "react-bootstrap"
import GeneralServices from '../components/GeneralServices'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { listProducts, getProjectsInfo,getAgencyProjectsInfo } from '../actions/productActions'
import "../css/style.css"
import { useMediaQuery } from 'react-responsive'
import './css/screensStyling.css'

const server = "https://transportation-backend-test.link"
const GeneralHomeScreen = ({match}) => {
const dispatch=useDispatch()

const productList=useSelector(state=>state.productList)
const { loading, error, products } = productList

const projectListInfo=useSelector(state=>state.projectListInfo)
const {loadingInfo,errorInfo,projectsInfo} =projectListInfo

const agencyProjectListInfo=useSelector(state=>state.agencyProjectListInfo)
const {loadingAgencyInfo,errorAgencyInfo,agencyProjectsInfo} =agencyProjectListInfo

//const [specialZone, setspecialZone] = useState(0)
  
const isDesktopOrLaptop = useMediaQuery({
      query: '(min-width: 1224px)'
    })
const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })  
const [projectName, setProjectName] = useState('ejemplo')
  
  const fetchProjectInfo = async (projectId) => {
    const { data } = await axios.get(`${server}/projects-info/${projectId}`)
    setProjectName(data[0].name);
  }

  useEffect(() => {
    dispatch(listProducts())
    dispatch(getProjectsInfo(83))
    dispatch(getAgencyProjectsInfo(match.params.agencyProjectId))
    fetchProjectInfo(83)
  }, [dispatch])
  
  
  return (
    <>
   <Container className="text-center">

    <Row className="text-center">

      <Col>
      {projectsInfo.map((project,index) => (

          <div key={project.id}
          style={ { 
            width: "1067",
            height: "100%"
          } }
          className="responsive-image">
          <div style={ {
              paddingBottom: ( 500 / 1067 * 100 ) + '%'
            } } />
          <img    
          src={project.image} alt={project.name}
            className="responsive-image__image" />
        </div> 
          ))}    

      </Col>

    </Row>
 
    <Row className="text-center">

      <Col>
      {agencyProjectsInfo.map((project,index) => (

          <div key={project.id}
          style={ { 
            width: "1067",
            height: "100%"
          } }
          className="responsive-image">
          <div style={ {
              paddingBottom: ( 613 / 1067 * 100 ) + '%'
            } } />
          <img    
          src={project.image} alt={project.name}
            className="responsive-image__image" />           
        </div>          
          ))}    

      </Col>

    </Row>
    <Row className="text-center">
      <Col>
            <Card className="cardBackground">
              <Card.Body>
                <Card.Title className="cardTitle">Welcome!</Card.Title>
                <Card.Text className="cardText">
We're so happy you're joining us in Los Cabos to celebrate love!
To make your experience as smooth and stress-free as possible, we've partnered with a trusted local transportation company. Below, you'll find links to each wedding's transportation details — simply select the event you're attending and book your ride directly.
Whether you're heading to the welcome party, ceremony, or back to your hotel, we've got you covered.
Let’s make it easy — and memorable — from the very first ride.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

    </Row>    
    <Row className="text-center">
          
          <Col>
      {agencyProjectsInfo.map((project,index) => (
        <div key={project.id}>
          {isDesktopOrLaptop && <h2>{project.name}</h2>}
          {isBigScreen && <h1>{project.name}</h1>}
          {isTabletOrMobile && <h6>{project.name}</h6>}

          {isDesktopOrLaptop && <h1 class="screensH1">Please Select Your Transportation:</h1>}
          {isBigScreen && <h1 class="screensH1">Please Select Your Transportation:</h1>}
          {isTabletOrMobile && <h5 class="screensH1">Please Select Your Transportation:</h5>}
        </div>
       ))}    
      </Col>

    </Row>

  </Container>      
      
      {loading?<Loader/>:error?<Message variant='danger'>{error}</Message>: 
      <Row>        
          {products.map((product,index) => (
            <Col key={product._id} sm={12} md={6} lg={4} xl={4}>              
                  <GeneralServices product={product} projectId={83} agencyProjectId={match.params.agencyProjectId} projectName={projectName} />                  
              </Col>
          ))}    
      </Row>
      }     
    </>
  )
}

export default GeneralHomeScreen
